import {Component, ElementRef, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import { Router } from '@angular/router';

@Component({
    selector: 'header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.css'],
    moduleId: module.id
})
export class HeaderComponent implements OnInit{
    languages: any[] = [];
    menuOpen: boolean = false;
    constructor(
        private userService: UserService,
        private router: Router,
        private eref: ElementRef
    ) {
        this.router = router;
    };

    isLoggedIn(): boolean {
        return this.userService.isLoggedIn();
    }

    onClick(event: any) {
        if (!this.eref.nativeElement.contains(event.target)) {
            this.menuOpen = false;
        }
    }

    ngOnInit(): void {
        this.languages = [
            {
                name: "English (US)",
                thumbnailUrl: "assets/flags/usa.gif",
            }
        ];
    };

    logout(): void {
        let me = this;
        this.menuOpen = false;
        this.userService.logout().then(function(){
            me.router.navigate(['login'])
        })
    }

    expandMenu(): void {
        this.menuOpen = true;
    }

    selectLanguage(language: any): void {
        //TODO - set the language for the app
        this.menuOpen = false;
    }

    getUserEmail() : string {
        return this.userService.userEmail;
    }

    isUserTab(url: string): boolean {
        return /^\/user/.test(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts